import { SetStateAction, useEffect, useState } from "react";
import upArrow from "../../assets/uparrowFilter.svg";
import downArrow from "../../assets/downarrowFilter.svg";
import reload from "../../assets/reload.svg";
import { useDispatch, useSelector } from "react-redux";
import { IRoot } from "../../services/interface/IHome";
import { IRoot as IDemandRoot } from "../../services/interface/IDemand";
import { OverviewCard } from "../../components/OverviewCard";
import Graph from "../../common/Graph";
import { useForecastOverViewDropDownFilter } from "../../services/redux/hooks/useDemand";
import { setApplyFilter } from "../../services/redux/reducer/demandfilter.reducer";
import CustomLoader from "../../common/CustomLoader/CustomLoader";
import moment from "moment";
import FilterComponent from "../../components/FilterComponent";
import { Button, Radio, RadioGroup } from "rsuite";
import { formatFilterName } from "../../utils/formatter";
import { useGetcurrentOnHandVSTargetInventoryMutation, useGetOnHandVSTargetInventoryMutation } from "../../services/redux/api/onHandSoqApi";
import { ApiData, IKeyValueData, Mapping } from "../../services/interface/IReplenishment";

const OnHandVsTarget = () => {
    const dispatch = useDispatch();
    const initialState: { [key: string]: string[] } = {
        dc:[],  
        category: [],
        subCategory: [],
        productSegm: [],
        productDesc: [],
        itemId: [],
        vendorName: [],
    }
    const [isVisible, setIsVisible] = useState<boolean>(true);
    const [selectedFilterData, setSelectedFilterData] = useState<{
        [key: string]: string[];
    }>(initialState);
    const [lineGraphData, setLineGraphData] = useState([]);
    const [overViewData, setOverviewData] = useState<any>();
    const [currentBarData, setCurrentBarData] = useState<any>();
    const [inventoryAnalysis, setInventoryAnalysis] = useState<any>();
    const lastUpdated = useSelector((state: IRoot) => state.filter.lastUpdateDate) || "";
    const { mutate: mutateDropDown, isLoading, data: resFilterData } = useForecastOverViewDropDownFilter();
    const [getcurrentOnHandVSTargetInventory, {isLoading: isOnHandLoading, data: resOnHandData}] = useGetcurrentOnHandVSTargetInventoryMutation();
    const [getOnHandVSTargetInventory, {isLoading: isCardsLoading, data: resOnHandCardDara}] = useGetOnHandVSTargetInventoryMutation();
    const applyFilter = useSelector((state:IDemandRoot)=>state.dbfilter.applyFilter) || "";

    const [filters, setFilters] = useState({
        dc: [],
        category: [],
        subCategory: [],
        productSegm: [],
        productDesc: [],
        itemId: [],
        vendorName: [],
    });

    const [radioKey, setRadioKey] = useState<string>("BranchId");

    const filterNamesMap: { [key: string]: string } = {
        dc: "DC",
        productSegm: "Segmentation",
        vendorName: "Vendor"
    };

    const prepareInventoryData = (apiData: ApiData) => {
        const mapping: Mapping = {
            "inventoryOnHand": { key: "Inventory on Hand", targetKey: "targetInventory" },
            "excess": { key: "Excess Inventory", targetKey: null },
            "insufficient": { key: "Insufficient Inventory", targetKey: null },
            "inventoryTurnsActual": { key: "Inventory Turns", targetKey: "inventoryTurnsTarget" },
            "daysOfSupplyActual": { key: "Days of Supply", targetKey: "daysOfSupplyTarget" },
            "daysOnHandActual": { key: "Days on Hand", targetKey: "daysOnHandTarget" },
        };
    
        return Object.keys(mapping).map((apiField: string) => {
            const apiDataEntry = apiData.find((item: any) => Object.keys(item).includes(apiField));
    
            if (!apiDataEntry) {
                console.warn(`API field '${apiField}' not found.`);
                return null;
            }
    
            const { key, targetKey } = mapping[apiField];
            let className = "text-deloitteGreen"; 
            let value = apiDataEntry[apiField];
            let target = targetKey ? apiDataEntry[targetKey] : null;
    
            if (["Excess Inventory", "Insufficient Inventory"].includes(key)) {
                className = value === 0 ? "text-deloitteGreen" : "text-alert";
            } else if (target !== null && value !== null) {
                const percentageDifference = ((value - target) / target) * 100;
 
                if (percentageDifference < -10 || percentageDifference > 10) {
                    className = "text-alert";
                }
            }
    
            return {
                key,
                value,
                target,
                className,
            };
        });
    };
    

    const prepateDailyTrendData = (apiData: ApiData) => {
        const finalData:any = [];
        Array.isArray(apiData) && apiData?.map((each)=>{
            let obj = {
                "forecastDate":moment(each?.InventoryDate?.slice(0, 10)).format("DD-MMM"),
                "onHandLb": each?.onHandLb,
                "Excess": each?.Excess,
                "Insufficient": each?.Insufficient,
            }
            finalData.push(obj);
        });
        setLineGraphData(finalData);
    }

    const handleChange = (e: any) => {
        setRadioKey(e);
    }

    const filterShowHandler = () => {
        setIsVisible((prev) => !prev);
    };

    const applyHandler = () => {
        dispatch(setApplyFilter("applied"));
    }
    
    const removeHandler = () => {
        setSelectedFilterData(initialState);
        dispatch(setApplyFilter(""));
    }
    
    const handleFilterChange = (filterKey: string, value: string | string[]) => {
        const newValue = Array.isArray(value) ? value : [value];
        setSelectedFilterData(prevState => ({
            ...prevState,
            [filterKey]: newValue,
        }));
    };

    const callForecastFilterApi = async () => {
        try {
            const response = await mutateDropDown(
                selectedFilterData as any
            ).unwrap();
            setFilters(prevFilters => ({
                dc: response?.data?.dc || [],
                category: response?.data?.category || [],
                subCategory: response?.data?.subCategory || [],
                productSegm: response?.data?.productSegm || [],
                productDesc: response?.data?.productDesc || [],
                itemId: response?.data?.itemId || [],
                vendorName: response?.data?.vendorName || [],
            }));
        } catch (error) {
            console.error("Failed to fetch forecast filter data:", error);
        }
    };

    const callGetOnHandVSTargetInventoryApi=async()=>{
        try {
            const response = await getOnHandVSTargetInventory(
                selectedFilterData as any
            ).unwrap();
            const res = prepareInventoryData(response?.data?.cardData);
            prepateDailyTrendData(response?.data?.lineChartData);
            setOverviewData(res);
        } catch (error) {
            console.error("Failed to fetch forecast filter data:", error);
        }
    }

    const callCurrentOnHandTargetApi = async(payload:any)=>{
        try {
            const response = await getcurrentOnHandVSTargetInventory(payload).unwrap();
            setCurrentBarData(response?.data?.currentOnHand);
            setInventoryAnalysis(response?.data?.inventoryAnalysis);
          } catch (error) {
            console.error("Failed to fetch inventory projection data:", error);
          }
    }

    useEffect(() => {
        if (applyFilter === "" || applyFilter === "applied") {
            const payload = {
                ...selectedFilterData,
                filterDc: radioKey === "BranchId" ? radioKey : "",
                filterCategory: radioKey === "category" ? radioKey : "",
                filterSubCategory: radioKey === "subCategory" ? radioKey : "",
                filterSegments: radioKey === "Final_Segment_erp" ? radioKey : "",
            }
            callCurrentOnHandTargetApi(payload);
            callGetOnHandVSTargetInventoryApi();
        }
    }, [applyFilter, radioKey]);

    return <>
        <div className="flex flex-col bg-[#F1F1F1] h-[88vh]">
            <div className="relative bg-[#FFF]">
                <div className={`flex flex-col gap-1 px-[2%] border-b-[1px] shadow ${!isVisible ? "pt-[8px] pb-[2px]" : "pt-[8px] pb-[15px]"}`}>
                    <div className="flex justify-between items-center mb-1">
                        <h3 className="page-title font-semibold">{"Inventory & Replenishment > On Hand vs Target"}</h3>
                        {<div className="flex gap-2">
                            <img src={reload} alt="reload" className="w-[1vw]" />
                            <p className="chart-title text-[#858585] font-semibold">Last Updated : 02/27/2024</p>
                        </div>}
                    </div>

                    {/* Filters Section */}
                    {isVisible && <div className="grid grid-cols-[1fr_auto] items-end gap-4 filter-div">
                        <div className="grid grid-cols-10 gap-2 items-end">
                            {filters &&
                                Object.entries(filters).map(
                                    ([filterKey, filterArray]: [string, any[]]) => (
                                        <FilterComponent
                                            loading={isLoading}
                                            key={filterKey}
                                            filterKey={filterKey}
                                            filterName={filterNamesMap[filterKey] || formatFilterName(filterKey)}
                                            options={filterArray.map((opt) => ({
                                                label: opt.filterVal,
                                                value: opt.filterValue || opt.filterVal,
                                            }))}
                                            labelKey="label"
                                            valueKey="value"
                                            value={selectedFilterData[filterKey] || []}
                                            onFilterChange={handleFilterChange}
                                            onDropdownOpen={callForecastFilterApi}
                                        />
                                    )
                                )}
                        </div>
                        <div className="align-right flex gap-1">
                            <Button onClick={removeHandler} className="bg-[#949494] text-white px-[20px] h-[4vh] rounded font-semibold chart-title">
                                Clear
                            </Button>
                            <Button onClick={applyHandler} className="bg-deloitteGreen text-white px-[20px] h-[4vh] rounded font-semibold chart-title">
                                Apply
                            </Button>
                        </div>
                    </div>}

                    <div onClick={filterShowHandler} className="flex justify-center absolute left-2/4 top-full translate-x-[-50%] translate-y-[-50%] cursor-pointer z-[10]">
                        {isVisible && <img className="w-[1.5vw]" src={upArrow} alt="upArrow" />}
                        {!isVisible && <img className="w-[1.5vw]" src={downArrow} alt="downArrow" />}
                    </div>
                </div>
            </div>
            <div className={`grid grid-cols-6 px-[2%] pt-2 pb-0 gap-2 bg-[#f1f1f1] ${isVisible ? "h-[15vh]" : "h-[17vh]"}`}>
                {overViewData?.map((data: any, index: number) => {
                    const isAbsolute = true;
                    const updatedData = { ...data, isAbsolute };
                    return (
                        <OverviewCard
                            key={index}
                            card={updatedData}
                        />
                    );
                })}
            </div>
            <div className={`px-[2%] pt-2 pb-0 bg-[#f1f1f1] ${isVisible ? "h-[27vh]" : "h-[28vh]"}`}>
                <Graph
                    title="Daily Inventory Trend (Last 28 Days)"
                    graphTypes={["bar", "bar"]}
                    data={lineGraphData}
                    dataKey={[ "Excess", "Insufficient"]}
                    dataName={[ "Excess", "Insufficient"]}
                    fill={[ "#0097A9", "#BC2525"]}
                    xAxisKey="forecastDate"
                    // yAxisKey="Excess"
                    onClick={() => { }}
                    interval={1}
                    stack={{
                        enabled: true,
                        id: "a",
                      }}
                />
            </div>
            <div className={`bg-[#F1F1F1] px-[2%] py-2 ${isVisible ? "h-[27vh]" : "h-[32vh]"}`}>
                <div className="grid grid-cols-[0.2fr_1fr_1fr] gap-2 h-full">
                    <div className="pl-2">
                        <label className="chart-title font-bold">View By</label>
                        <RadioGroup name="View By" value={radioKey} onChange={handleChange}>
                            <Radio className="chart-title" name="filterDc" value="BranchId">DC</Radio>
                            <Radio className="chart-title" name="filterCategory" value="category">Category</Radio>
                            <Radio className="chart-title" name="filterSubCategory" value="subCategory">SubCategory</Radio>
                            <Radio className="chart-title" name="filterSegments" value="Final_Segment_erp">Segment</Radio>
                        </RadioGroup>
                    </div>
                    <Graph
                        title="Current On Hand (02/27/2024) vs Target"
                        graphTypes={["bar", "bar"]}
                        data={currentBarData}
                        dataKey={["onHandlb", "targetStocklbs"]}
                        dataName={["Actual", "Target Stock"]}
                        fill={["#012169", "#86BC25"]}
                        stack={{
                            enabled: false,
                            id: 'inventory'
                        }}
                        xAxisKey={radioKey.charAt(0).toUpperCase() + radioKey.slice(1)}
                        onClick={() => { }}
                        scrollable={true}
                        interval={0}
                        width={15}
                        barGap={0}
                        margin={{ top: 15, right: 20, bottom: 5, left: 10 }}
                        isRequiredTickFormatter={true}
                        isRequiredYAxisFormatter={false}
                    />
                    <Graph
                        title="Inventory Analysis (02/27/2024)"
                        graphTypes={["bar", "bar"]}
                        data={inventoryAnalysis}
                        dataKey={["insufficientInventory", "excessInventory"]}
                        dataName={["Insufficient Inventory", "Excess Inventory"]}
                        fill={["#BC2525", "#0097A9"]}
                        xAxisKey={radioKey.charAt(0).toUpperCase() + radioKey.slice(1)}
                        onClick={() => { }}
                        scrollable={true}
                        interval={0}
                        stack={{
                            enabled: true,
                            id: "b",
                          }}
                        isRequiredTickFormatter={true}
                        isRequiredYAxisFormatter={false}
                    />
                </div>
            </div>
        </div>
        {(isLoading || isOnHandLoading || isCardsLoading) && <CustomLoader open={isLoading || isOnHandLoading || isCardsLoading} />}
    </>
}

export default OnHandVsTarget;